import { Theme } from '@mui/material/styles';
export default function DatePicker(theme: Theme) {
    return {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '&[data-input="date-picker"][data-displayed-only="true"]': {
                        input: {
                            WebkitTextFillColor: theme.palette.text.primary,
                        },
                    },
                    '.Mui-readOnly': {
                        '.MuiInputAdornment-root': {
                            display: 'none',
                        },
                    },
                    '& .MuiInputAdornment-root .MuiButtonBase-root': {
                        border: 'none',
                        '&:hover': {
                            backgroundColor: theme.palette.primary.light,
                        },
                        '&:focus': {
                            outline: 'none',
                        },
                    },
                    marginTop: '0 !important',
                },
            },
        },
    };
}
